import { black } from "@/styles/variable"
import styled from "styled-components"

export const MySessionActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`
export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: ${black["0060"]};
  }

  &:active {
    background: ${black["1F"]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
